// extracted by mini-css-extract-plugin
export default {"body_wrapper":"AutoFitDocument_body_wrapper__doHHk","wrapper":"AutoFitDocument_wrapper__NqU0U","box":"AutoFitDocument_box__5G4cf"};